export default {
  mice: {
    SendInvitation: '/api/engine/event/Attender/SendInvitation', //发送邀约
    AcceptInvitation: '/api/engine/event/Attender/AcceptInvitation', // 是否接受邀约
  },
  identity: {
    // getme:'/api/identity/account/getme'//个人资料
    getme: '/foundation/passport/IUserService/GetMe', //个人信息
    clearAlipayId: '/api/foundation/user/clearAlipayId', //清除授权
  },
  message: {
    Query: "/api/service/notification/MqMessagePushLog/Paging", // 消息查询
	GetInvitation: "/api/engine/event/Attender/GetInvitation", // 获取邀约会议详情
  },
  disclaimer: {
    GetAttenderDisclaimer: "/Disclaimer/GetAttenderDisclaimer" //获取免责声明内容
  }

}



// WEBPACK FOOTER //
// ./src/apis/urls.js